export const RegularServicedSites = () => {
    return (
        <div>
            reg serv sites
        </div>
    )
}